export default __webpack_public_path__ + "static/media/Sympa.5503395e.svg";